import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  deNextBestQuestionsQuery as deNextBestQuestionsQueryType,
} from "@/modules/chats/services/ai/de/__generated__/deNextBestQuestionsQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query deNextBestQuestionsQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    nextBestQuestions: de_nextBestQuestions(aiRequestMetadata: $aiRequestMetadata) {
      questions
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const deNextBestQuestionsQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<deNextBestQuestionsQueryType>(RelayEnvironment, query, { aiRequestMetadata }).toPromise()
}
